var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { themeSpacing } from '../../utils';
import { Row } from '../Grid';
const FooterBottomStyle = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin: ${themeSpacing(3, 0)};

  & > *:not(:last-of-type) {
    margin-right: ${themeSpacing(7)};
  }
`;
const FooterBottom = (_a) => {
    var { children } = _a, otherProps = __rest(_a, ["children"]);
    return (React.createElement(Row, null,
        React.createElement(FooterBottomStyle, Object.assign({}, otherProps), children)));
};
export default FooterBottom;
//# sourceMappingURL=FooterBottom.js.map